var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1H5.25C4.0125 1 3.01125 1.99 3.01125 3.2L3 20.8C3 22.01 4.00125 23 5.23875 23H18.75C19.9875 23 21 22.01 21 20.8V8L14 1ZM13 9V3L19 9H13ZM16 12L13.2 15.5L16 19H13.6L12 16.9997L10.4 19H8L10.8 15.5L8 12H10.4L12 14.0002L13.6 12H16Z",
    fill: "currentColor"
  })));
}

export default SvgExcel;